import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2 } from '@/api/model/interfaces';

export default class KS2ReportsOdata extends OdataManager<PackageKS2> {}
